import { Ya360Disk } from '@yandex-360/iconostasis/dist/icons/Ya360Disk';
import { Ya360Mail } from '@yandex-360/iconostasis/dist/icons/Ya360Mail';
import { Ya360Calendar } from '@yandex-360/iconostasis/dist/icons/Ya360Calendar';
import { Ya360Telemost } from '@yandex-360/iconostasis/dist/icons/Ya360Telemost';
import { Ya360Boards } from '@yandex-360/iconostasis/dist/icons/Ya360Boards';
import { Ya360Docs } from '@yandex-360/iconostasis/dist/icons/Ya360Docs';
import { Ya360Wiki } from '@yandex-360/iconostasis/dist/icons/Ya360Wiki';
import { Ya360Tracker } from '@yandex-360/iconostasis/dist/icons/Ya360Tracker';
import { Ya360Forms } from '@yandex-360/iconostasis/dist/icons/Ya360Forms';
import { Service } from '@yandex-360/global-bar';
import { type Brand } from '@yandex-360/orb-components/dist/components/Theme/_brands';
import { type TranslationKey } from '@/i18n';

import diskMain from '../../../assets/images/disk.png';
import mailMain from '../../../assets/images/mail.png';
import calendarMain from '../../../assets/images/calendar.png';
import telemostMain from '../../../assets/images/telemost.png';
import boardsMain from '../../../assets/images/boards.png';
import docsMain from '../../../assets/images/docs.png';
import wikiMain from '../../../assets/images/wiki.png';
import trackerMain from '../../../assets/images/tracker.png';
import formsMain from '../../../assets/images/forms.png';

import diskFeature1 from '../../../assets/icons/disk1.svg';
import diskFeature2 from '../../../assets/icons/disk2.svg';
import diskFeature3 from '../../../assets/icons/disk3.svg';
import diskFeature4 from '../../../assets/icons/disk4.svg';
import diskFeature5 from '../../../assets/icons/disk5.svg';
import diskFeature6 from '../../../assets/icons/disk6.svg';

import boardFeature1 from '../../../assets/icons/boards1.svg';
import boardFeature2 from '../../../assets/icons/boards2.svg';
import boardFeature3 from '../../../assets/icons/boards3.svg';
import boardFeature4 from '../../../assets/icons/boards4.svg';
import boardFeature5 from '../../../assets/icons/boards5.svg';
import boardFeature6 from '../../../assets/icons/boards6.svg';

import docsFeature1 from '../../../assets/icons/docs1.svg';
import docsFeature2 from '../../../assets/icons/docs2.svg';
import docsFeature3 from '../../../assets/icons/docs3.svg';
import docsFeature4 from '../../../assets/icons/docs4.svg';
import docsFeature5 from '../../../assets/icons/docs5.svg';
import docsFeature6 from '../../../assets/icons/docs6.svg';

import wikiFeature1 from '../../../assets/icons/wiki1.svg';
import wikiFeature2 from '../../../assets/icons/wiki2.svg';
import wikiFeature3 from '../../../assets/icons/wiki3.svg';
import wikiFeature4 from '../../../assets/icons/wiki4.svg';
import wikiFeature5 from '../../../assets/icons/wiki5.svg';
import wikiFeature6 from '../../../assets/icons/wiki6.svg';

import trackerFeature1 from '../../../assets/icons/tracker1.svg';
import trackerFeature2 from '../../../assets/icons/tracker2.svg';
import trackerFeature3 from '../../../assets/icons/tracker3.svg';
import trackerFeature4 from '../../../assets/icons/tracker4.svg';
import trackerFeature5 from '../../../assets/icons/tracker5.svg';
import trackerFeature6 from '../../../assets/icons/tracker6.svg';

import formsFeature1 from '../../../assets/icons/forms1.svg';
import formsFeature2 from '../../../assets/icons/forms2.svg';
import formsFeature3 from '../../../assets/icons/forms3.svg';
import formsFeature4 from '../../../assets/icons/forms4.svg';
import formsFeature5 from '../../../assets/icons/forms5.svg';
import formsFeature6 from '../../../assets/icons/forms6.svg';

import mailFeature1 from '../../../assets/icons/mail1.svg';
import mailFeature2 from '../../../assets/icons/mail2.svg';
import mailFeature3 from '../../../assets/icons/mail3.svg';
import mailFeature4 from '../../../assets/icons/mail4.svg';
import mailFeature5 from '../../../assets/icons/mail5.svg';
import mailFeature6 from '../../../assets/icons/mail6.svg';

import calendarFeature1 from '../../../assets/icons/calendar1.svg';
import calendarFeature2 from '../../../assets/icons/calendar2.svg';
import calendarFeature3 from '../../../assets/icons/calendar3.svg';
import calendarFeature4 from '../../../assets/icons/calendar4.svg';
import calendarFeature5 from '../../../assets/icons/calendar5.svg';
import calendarFeature6 from '../../../assets/icons/calendar6.svg';

import telemostFeature1 from '../../../assets/icons/telemost1.svg';
import telemostFeature2 from '../../../assets/icons/telemost2.svg';
import telemostFeature3 from '../../../assets/icons/telemost3.svg';
import telemostFeature4 from '../../../assets/icons/telemost4.svg';
import telemostFeature5 from '../../../assets/icons/telemost5.svg';
import telemostFeature6 from '../../../assets/icons/telemost6.svg';

export type ServiceData = {
    id: Service;
    brand: Brand;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    icon: React.ComponentType<any>;
    title: TranslationKey;
    subTitle: TranslationKey;
    linkText: TranslationKey;
    downloadLinkTitle?: TranslationKey;
    featuresTitle: TranslationKey;
    heroImage: string;
    features: {
        title: TranslationKey;
        text: TranslationKey;
        icon: string;
    }[];
};

export const servicesData: ServiceData[] = [
    {
        id: 'Disk',
        brand: 'disk',
        icon: Ya360Disk,
        title: 'service.disk.title',
        subTitle: 'service.disk.subtitle',
        linkText: 'service.disk.open',
        downloadLinkTitle: 'service.disk.download',
        featuresTitle: 'service.disk.features-title',
        heroImage: diskMain,
        features: [
            {
                title: 'service.disk.feature-1.title',
                text: 'service.disk.feature-1.text',
                icon: diskFeature1,
            },
            {
                title: 'service.disk.feature-2.title',
                text: 'service.disk.feature-2.text',
                icon: diskFeature2,
            },
            {
                title: 'service.disk.feature-3.title',
                text: 'service.disk.feature-3.text',
                icon: diskFeature3,
            },
            {
                title: 'service.disk.feature-4.title',
                text: 'service.disk.feature-4.text',
                icon: diskFeature4,
            },
            {
                title: 'service.disk.feature-5.title',
                text: 'service.disk.feature-5.text',
                icon: diskFeature5,
            },
            {
                title: 'service.disk.feature-6.title',
                text: 'service.disk.feature-6.text',
                icon: diskFeature6,
            },
        ],
    },
    {
        id: 'Mail',
        brand: 'mail',
        icon: Ya360Mail,
        title: 'service.mail.title',
        subTitle: 'service.mail.subtitle',
        linkText: 'service.mail.open',
        featuresTitle: 'service.mail.features-title',
        heroImage: mailMain,
        features: [
            { title: 'service.mail.feature-1.title', text: 'service.mail.feature-1.text', icon: mailFeature1 },
            { title: 'service.mail.feature-2.title', text: 'service.mail.feature-2.text', icon: mailFeature2 },
            { title: 'service.mail.feature-3.title', text: 'service.mail.feature-3.text', icon: mailFeature3 },
            { title: 'service.mail.feature-4.title', text: 'service.mail.feature-4.text', icon: mailFeature4 },
            { title: 'service.mail.feature-5.title', text: 'service.mail.feature-5.text', icon: mailFeature5 },
            { title: 'service.mail.feature-6.title', text: 'service.mail.feature-6.text', icon: mailFeature6 },
        ],
    },
    {
        id: 'Calendar',
        brand: 'calendar',
        icon: Ya360Calendar,
        title: 'service.calendar.title',
        subTitle: 'service.calendar.subtitle',
        linkText: 'service.calendar.open',
        downloadLinkTitle: 'service.disk.download',
        featuresTitle: 'service.calendar.features-title',
        heroImage: calendarMain,
        features: [
            { title: 'service.calendar.feature-1.title', text: 'service.calendar.feature-1.text', icon: calendarFeature1 },
            { title: 'service.calendar.feature-2.title', text: 'service.calendar.feature-2.text', icon: calendarFeature2 },
            { title: 'service.calendar.feature-3.title', text: 'service.calendar.feature-3.text', icon: calendarFeature3 },
            { title: 'service.calendar.feature-4.title', text: 'service.calendar.feature-4.text', icon: calendarFeature4 },
            { title: 'service.calendar.feature-5.title', text: 'service.calendar.feature-5.text', icon: calendarFeature5 },
            { title: 'service.calendar.feature-6.title', text: 'service.calendar.feature-6.text', icon: calendarFeature6 },
        ],
    },
    {
        id: 'Telemost',
        brand: 'telemost',
        icon: Ya360Telemost,
        title: 'service.telemost.title',
        subTitle: 'service.telemost.subtitle',
        linkText: 'service.telemost.open',
        downloadLinkTitle: 'service.disk.download',
        featuresTitle: 'service.telemost.features-title',
        heroImage: telemostMain,
        features: [
            { title: 'service.telemost.feature-1.title', text: 'service.telemost.feature-1.text', icon: telemostFeature1 },
            { title: 'service.telemost.feature-2.title', text: 'service.telemost.feature-2.text', icon: telemostFeature2 },
            { title: 'service.telemost.feature-3.title', text: 'service.telemost.feature-3.text', icon: telemostFeature3 },
            { title: 'service.telemost.feature-4.title', text: 'service.telemost.feature-4.text', icon: telemostFeature4 },
            { title: 'service.telemost.feature-5.title', text: 'service.telemost.feature-5.text', icon: telemostFeature5 },
            { title: 'service.telemost.feature-6.title', text: 'service.telemost.feature-6.text', icon: telemostFeature6 },
        ],
    },
    {
        id: 'Concept',
        brand: 'boards',
        icon: Ya360Boards,
        title: 'service.boards.title',
        subTitle: 'service.boards.subtitle',
        linkText: 'service.boards.open',
        featuresTitle: 'service.boards.features-title',
        heroImage: boardsMain,
        features: [
            {
                title: 'service.boards.feature-1.title',
                text: 'service.boards.feature-1.text',
                icon: boardFeature1,
            },
            {
                title: 'service.boards.feature-2.title',
                text: 'service.boards.feature-2.text',
                icon: boardFeature2,
            },
            {
                title: 'service.boards.feature-3.title',
                text: 'service.boards.feature-3.text',
                icon: boardFeature3,
            },
            {
                title: 'service.boards.feature-4.title',
                text: 'service.boards.feature-4.text',
                icon: boardFeature4,
            },
            {
                title: 'service.boards.feature-5.title',
                text: 'service.boards.feature-5.text',
                icon: boardFeature5,
            },
            {
                title: 'service.boards.feature-6.title',
                text: 'service.boards.feature-6.text',
                icon: boardFeature6,
            },
        ],
    },
    {
        id: 'Documents',
        brand: 'docs',
        icon: Ya360Docs,
        title: 'service.docs.title',
        subTitle: 'service.docs.subtitle',
        linkText: 'service.docs.open',
        featuresTitle: 'service.docs.features-title',
        heroImage: docsMain,
        features: [
            {
                title: 'service.docs.feature-1.title',
                text: 'service.docs.feature-1.text',
                icon: docsFeature1,
            },
            {
                title: 'service.docs.feature-2.title',
                text: 'service.docs.feature-2.text',
                icon: docsFeature2,
            },
            {
                title: 'service.docs.feature-3.title',
                text: 'service.docs.feature-3.text',
                icon: docsFeature3,
            },
            {
                title: 'service.docs.feature-4.title',
                text: 'service.docs.feature-4.text',
                icon: docsFeature4,
            },
            {
                title: 'service.docs.feature-5.title',
                text: 'service.docs.feature-5.text',
                icon: docsFeature5,
            },
            {
                title: 'service.docs.feature-6.title',
                text: 'service.docs.feature-6.text',
                icon: docsFeature6,
            },
        ],
    },
    {
        id: 'Wiki',
        brand: 'disk',
        icon: Ya360Wiki,
        title: 'service.wiki.title',
        subTitle: 'service.wiki.subtitle',
        linkText: 'service.wiki.open',
        featuresTitle: 'service.wiki.features-title',
        heroImage: wikiMain,
        features: [
            {
                title: 'service.wiki.feature-1.title',
                text: 'service.wiki.feature-1.text',
                icon: wikiFeature1,
            },
            {
                title: 'service.wiki.feature-2.title',
                text: 'service.wiki.feature-2.text',
                icon: wikiFeature2,
            },
            {
                title: 'service.wiki.feature-3.title',
                text: 'service.wiki.feature-3.text',
                icon: wikiFeature3,
            },
            {
                title: 'service.wiki.feature-4.title',
                text: 'service.wiki.feature-4.text',
                icon: wikiFeature4,
            },
            {
                title: 'service.wiki.feature-5.title',
                text: 'service.wiki.feature-5.text',
                icon: wikiFeature5,
            },
            {
                title: 'service.wiki.feature-6.title',
                text: 'service.wiki.feature-6.text',
                icon: wikiFeature6,
            },
        ],
    },
    {
        id: 'Tracker',
        brand: 'disk',
        icon: Ya360Tracker,
        title: 'service.tracker.title',
        subTitle: 'service.tracker.subtitle',
        linkText: 'service.tracker.open',
        featuresTitle: 'service.tracker.features-title',
        heroImage: trackerMain,
        features: [
            {
                title: 'service.tracker.feature-1.title',
                text: 'service.tracker.feature-1.text',
                icon: trackerFeature1,
            },
            {
                title: 'service.tracker.feature-2.title',
                text: 'service.tracker.feature-2.text',
                icon: trackerFeature2,
            },
            {
                title: 'service.tracker.feature-3.title',
                text: 'service.tracker.feature-3.text',
                icon: trackerFeature3,
            },
            {
                title: 'service.tracker.feature-4.title',
                text: 'service.tracker.feature-4.text',
                icon: trackerFeature4,
            },
            {
                title: 'service.tracker.feature-5.title',
                text: 'service.tracker.feature-5.text',
                icon: trackerFeature5,
            },
            {
                title: 'service.tracker.feature-6.title',
                text: 'service.tracker.feature-6.text',
                icon: trackerFeature6,
            },
        ],
    },
    {
        id: 'Forms',
        brand: 'disk',
        icon: Ya360Forms,
        title: 'service.forms.title',
        subTitle: 'service.forms.subtitle',
        linkText: 'service.forms.open',
        featuresTitle: 'service.forms.features-title',
        heroImage: formsMain,
        features: [
            {
                title: 'service.forms.feature-1.title',
                text: 'service.forms.feature-1.text',
                icon: formsFeature1,
            },
            {
                title: 'service.forms.feature-2.title',
                text: 'service.forms.feature-2.text',
                icon: formsFeature2,
            },
            {
                title: 'service.forms.feature-3.title',
                text: 'service.forms.feature-3.text',
                icon: formsFeature3,
            },
            {
                title: 'service.forms.feature-4.title',
                text: 'service.forms.feature-4.text',
                icon: formsFeature4,
            },
            {
                title: 'service.forms.feature-5.title',
                text: 'service.forms.feature-5.text',
                icon: formsFeature5,
            },
            {
                title: 'service.forms.feature-6.title',
                text: 'service.forms.feature-6.text',
                icon: formsFeature6,
            },
        ],
    },
];

export const getServiceById = (id: string): ServiceData | undefined =>
    servicesData.find(service => service.id === id);
